import { render, staticRenderFns } from "./ContributeAudit.vue?vue&type=template&id=edf80274"
import script from "./ContributeAudit.vue?vue&type=script&lang=js"
export * from "./ContributeAudit.vue?vue&type=script&lang=js"
import style0 from "./ContributeAudit.vue?vue&type=style&index=0&id=edf80274&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports